export default "__VITE_ASSET__CrF9j1HT__"